import dayjs from 'dayjs'

interface LessonDateFields {
  date_time?: string | null
  date_conference?: string | null
  start_time?: string | null
}

// Reports return both ISO dates and display strings such as «13.10.2026 в 12:30».
export const getLessonReportDateTime = (lesson: LessonDateFields) => {
  const normalize = (value?: string | null) => {
    if (!value) return null
    const text = value.trim().replace(/\s+в\s+/g, ' ')
      .replace(/^(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1')
    const parsed = dayjs(text)
    return parsed.isValid() ? { parsed, hasTime: /[T\s]\d{1,2}:\d{2}/.test(text) } : null
  }
  const value = normalize(lesson.date_time) ?? normalize(lesson.date_conference)
  if (!value) return { date: null, time: null, text: '—' }

  const separateTime = lesson.start_time?.match(/^(\d{1,2}):([0-5]\d)/)
  const time = value.hasTime
    ? value.parsed.format('HH:mm')
    : separateTime && Number(separateTime[1]) < 24
    ? `${separateTime[1].padStart(2, '0')}:${separateTime[2]}`
    : null

  return {
    date: value.parsed,
    time,
    text: [value.parsed.format('DD.MM.YYYY'), time].filter(Boolean).join('\n'),
  }
}
